import { RemainingLimitResponseDto } from '@shared/services/apiService/apiService';

export const getRemainingCallSeconds = (usageLimits: RemainingLimitResponseDto): number => {
  const callSecondsLimit = usageLimits.limits.find((l) => l.unit === 'call-second');
  return callSecondsLimit ? Number(callSecondsLimit.remaining) : Infinity;
};
